import { AddToastPayload } from 'modules/Layout/action';
import { ColorVariants } from 'modules/Shared/type';
import { TOAST_CLOSE_IN } from 'modules/Layout/type';

export const deleteDictionaryToastSuccess = (): AddToastPayload => ({
  header: 'Delete dictionary',
  body: 'Dictionary was deleted.',
  color: ColorVariants.Success,
  closeIn: TOAST_CLOSE_IN
});

export const deleteDictionaryToastError = (): AddToastPayload => ({
  header: 'Delete dictionary',
  body: 'Dictionary was not deleted.',
  color: ColorVariants.Danger,
  closeIn: TOAST_CLOSE_IN
});
